module.exports = __webpack_public_path__ + "static/media/BH-Medusa-Gold.f9d47b4b.png";